export const moneyHeadingStyles = {
  'h1, h2, h3': {
    color: '#924a8b',
    lineHeight: '120%',
    fontWeight: '600',
  },
  h2: {
    marginBottom: '24px !important',
    '@media screen and (min-width: 768px)': { marginBottom: '32px !important' },
  },
  'h1, h2': { fontSize: '30px', '@media screen and (min-width: 768px)': { fontSize: '36px' } },
  h3: {
    fontSize: '24px',
    '@media screen and (min-width: 768px)': { fontSize: '30px' },
  },
}

export const uswitchHeadingStyles = {
  'h1, h2, h3': {
    color: '#141414',
    lineHeight: '125%',
    fontWeight: '600',
    marginBottom: '24px !important',
  },
  'h1, h2': {
    fontSize: '32px',
    '@media screen and (min-width: 768px)': {
      fontSize: '40px',
    },
  },
  h3: {
    fontSize: '24px',
    '@media screen and (min-width: 768px)': {
      fontSize: '28px',
    },
  },
}

const confusedHeadingStyles = {
  'h1, h2, h3': {
    color: '#1F1F1F',
    lineHeight: '125%',
    fontWeight: '600',
    marginBottom: '12px !important',
  },
  'h1, h2': {
    fontSize: '32px',
    '@media screen and (min-width: 768px)': {
      fontSize: '48px',
    },
  },
  h3: {
    fontSize: '24px',
    '@media screen and (min-width: 768px)': {
      fontSize: '28px',
    },
  },
}

export const moneyRichTextBlockStyles = {
  ...moneyHeadingStyles,
  'p, a, a:visited, a:active, a:hover, li': {
    fontSize: '16px',
    lineHeight: '150%',
    '@media screen and (min-width: 768px)': { fontSize: '20px' },
  },
  p: {
    color: '#34454E',
  },
  'a, a:visited, a:active, a:hover': {
    textDecoration: 'underline',
    color: '#924a8b',
    cursor: 'pointer',
  },
  li: {
    color: '#34454E',
    '::before': {
      color: '#924a8b',
      'font-weight': 'bold',
    },
  },
  sup: {
    color: '#924a8b',
    fontSize: '8px',
    lineHeight: '150%',
    '@media screen and (min-width: 768px)': { fontSize: '12px' },
  },
  blockquote: {
    background: 'none',
    padding: 'inherit',
    '> p': {
      fontFamily: 'Nunito',
      color: '#DB4D75',
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '120%',
      borderLeft: 'none',
      paddingLeft: 0,
      '@media screen and (min-width: 768px)': { fontSize: '30px' },
    },
  },
}

export const uswitchRichTextBlockStyles = {
  ...uswitchHeadingStyles,
  'p, a, a:visited, a:active, a:hover, li': {
    fontSize: '16px',
    lineHeight: '150%',
    '@media screen and (min-width: 768px)': { fontSize: '18px' },
  },
  p: {
    color: '#434350',
  },
  'a, a:visited, a:active, a:hover': {
    textDecoration: 'underline',
    color: '#141414',
    cursor: 'pointer',
    borderBottom: 'none',
  },
  li: {
    marginBottom: '8px',
    color: '#434350',
    '::before': {
      marginBottom: '8px',
      color: '#141414',
    },
  },
  sup: {
    color: '#141414',
    fontSize: '8px',
    lineHeight: '150%',
    '@media screen and (min-width: 768px)': { fontSize: '12px' },
  },
  blockquote: {
    background: 'none',
    padding: 'inherit',
    '> p': {
      fontFamily:
        'Founders Grotesk, Helvetica Neue, Helvetica, Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Fira Sans, Droid Sans,sans-serif',
      color: '#141414',
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '120%',
      borderLeft: 'none',
      paddingLeft: 0,
      '@media screen and (min-width: 768px)': { fontSize: '30px' },
    },
  },
}
export const confusedhRichTextBlockStyles = {
  ...confusedHeadingStyles,
  'p, a, a:visited, a:active, a:hover, li': {
    fontSize: '16px',
    lineHeight: '150%',
    '@media screen and (min-width: 768px)': { fontSize: '20px' },
  },
  b: {
    fontWeight: '600',
  },
  p: {
    color: '#1F1F1F',
  },
  'a, a:visited, a:active, a:hover': {
    textDecoration: 'underline',
    color: '#1F1F1F',
    cursor: 'pointer',
    borderBottom: 'none',
  },
  li: {
    marginBottom: '8px',
    color: '#1F1F1F',
    '::before': {
      marginBottom: '8px',
      color: '#1F1F1F',
    },
  },
  sup: {
    color: '#1F1F1F',
    fontSize: '8px',
    lineHeight: '150%',
    '@media screen and (min-width: 768px)': { fontSize: '12px' },
  },
  blockquote: {
    background: 'none',
    padding: 'inherit',
    '> p': {
      fontFamily:
        'Helvetica Now Display, Helvetica Neue, Helvetica, Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Fira Sans, Droid Sans,sans-serif',
      color: '#1F1F1F',
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '120%',
      borderLeft: 'none',
      paddingLeft: 0,
      '@media screen and (min-width: 768px)': { fontSize: '30px' },
    },
  },
}

export const moneyQuoteStyles = {
  fontFamily: 'Nunito',
  color: '#DB4D75',
  fontSize: '24px',
  fontWeight: '600',
  lineHeight: '120%',
  '@media screen and (min-width: 768px)': { fontSize: '30px' },
}

export const uswitchQuoteStyles = {
  p: {
    fontFamily:
      'Founders Grotesk, Helvetica Neue, Helvetica, Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Fira Sans, Droid Sans,sans-serif',
    color: '#141414',
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '125%',
    '@media screen and (min-width: 768px)': { fontSize: '32px' },
  },
}

export const richTextBlockStyleByBrand = (brand) =>
  brand === 'money'
    ? moneyRichTextBlockStyles
    : brand === 'confused'
    ? confusedhRichTextBlockStyles
    : uswitchRichTextBlockStyles
